import { render, staticRenderFns } from "./Horde.vue?vue&type=template&id=cfeb5f58"
import script from "./Horde.vue?vue&type=script&lang=js"
export * from "./Horde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports